import styled from 'styled-components';

export const SnackbarNotificationComponentBox = styled.div<{bottomOffset?: number}>`
    background-color: ${props => props.theme.colors.snackbarNotificationBg || props.theme.colors.brandPrimaryContrast};
    color: ${props => props.theme.colors.textContrast};
    
    z-index: 100;
    position: fixed;
    bottom: ${props => props.bottomOffset + 'px'};
    left: 50%;
    transform: translate(-50%, -50%);
    
    font-size: 1.4rem;
    
    border-radius: 4px;
    padding: 12px 18px;
    
    display: flex;
    width: min(95%, 700px);
    ${({theme}) => theme.font.presets.regular};
      
      
      & span:first-of-type {
      flex-grow: 1;
    }
  
    & span:last-of-type {
      cursor: pointer;
      ${({theme}) => theme.font.presets.body};

    }

      animation: fadeInAnimation ease 0.5s;
      animation-fill-mode: forwards;  
      
      @keyframes fadeInAnimation {
            0% {
                  opacity: 0;
            }
            100% {
                  opacity: 1;
            }
      }
`;